await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false);

class DropdownDismiss extends McElement {

  connectedCallback() {
    this.addEventListener('click', () => {
      this.close();
    });
  }

  close = () => {
    setTimeout(() => {
      const dropdown = this.closest('.dropdown');
      if (!dropdown) {
        console.warn('DropdownDismiss: No dropdown found to close.');
        return;
      }

      const button = dropdown.querySelector('[data-bs-toggle="dropdown"]');
      if (!button) {
        console.warn('DropdownDismiss: No button found to toggle dropdown.');
        return;
      }

      const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(button);
      dropdownInstance.hide();
    });
  }
}

if (!customElements.get('dropdown-dismiss')) {
  customElements.define('dropdown-dismiss', DropdownDismiss);
}

window.DropdownDismiss = DropdownDismiss;